import type { ConsumerCheckoutCartsResponse } from '@givebacks/api/store';

import { createSafeContext } from '../../../utils';

const [CheckoutInfoProvider, useCheckoutInfoContext] = createSafeContext<{
  checkoutResponse: ConsumerCheckoutCartsResponse;
}>('CheckoutInfoProvider component was not found in tree');

export { CheckoutInfoProvider, useCheckoutInfoContext };
